// extracted by mini-css-extract-plugin
export default {"image":"aY-z","loaded":"bY-z"};